import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=645958c6&scoped=true"
import script from "./materials.vue?vue&type=script&lang=ts"
export * from "./materials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645958c6",
  null
  
)

export default component.exports